import { Box, TextField } from '@mui/material';
import { Field, FieldProps } from 'formik';
import { CamelCaseToNaturalCase } from 'utils/CamelCaseToNaturalCase';

type MuiTextAreaProps = {
	name: string;
	disabled?: boolean;
};

const MuiTextArea = (props: MuiTextAreaProps) => {
	const { name, ...rest } = props;
	return (
		<Field name={name}>
			{({ field, form }: FieldProps) => (
				<Box my={3}>
					<TextField
						id={name}
						size='small'
						variant='filled'
						fullWidth
						multiline
						rows={3}
						label={CamelCaseToNaturalCase(name)}
						error={form.errors[name] && form.touched[name] ? true : false}
						helperText={form.errors[name] && form.touched[name] ? form.errors[name] : null}
						{...rest}
						{...field}
					/>
				</Box>
			)}
		</Field>
	);
};

export default MuiTextArea;
